
import { App } from 'antd';
import Auth from './Auth';
import Manager from './Manager';
import { CmProvider } from './CmProvider';


function MainApp() {
  return (
    <App>
      <Auth>
        <CmProvider>
          <Manager />
        </CmProvider>
      </Auth>
    </App>
  );
}

export default MainApp;
